import React, { useState, useEffect, useContext } from 'react';
import { navigate } from 'gatsby';
import {
  Button,
  Dialog,
} from '@material-ui/core';

import SaveTwoToneIcon from '@material-ui/icons/SaveTwoTone';
import ReplayTwoToneIcon from '@material-ui/icons/ReplayTwoTone';

import { MyCardRow, MyCardSub } from 'components/Elements/MyCard';
import MyInput from 'components/Elements/MyInput';

import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { phone } from 'phone';

import { CircularProgressContext } from 'components/CircularProgressOverlay';
import { NotificationContext } from 'components/NotificationOverlay';

import { notNull, notEmpty, cleanPhone, formatPhone, isValidEmail } from 'utils/text';
import { logout } from 'services/loginService';
import { passengersService } from 'services/passengersService';
import { DialogTitleContainer, DialogContentContainer, DialogActionsContainer } from './style';

const EditSmsPhoneModal = ({
  passengerDetail,
  updatePassengerDetail,
  editOpen,
  handleEditClose,
}) => {
  const [values, setValues] = useState({});
  const [fieldErrors, setFieldErrors] = useState(null);
  const { showCircularProgress, hideCircularProgress } = useContext(CircularProgressContext);
  const { showNotification } = useContext(NotificationContext);

  useEffect(() => {
    setValues({
      sms_phone: passengerDetail.passenger_sms_phone || passengerDetail.passenger_phone,
      passenger_id: passengerDetail.passenger_id,
    });
  }, [passengerDetail]);

  const checkFieldValidate = (id, value) => {
    let valid = notNull(value) && (value.length > 0 || value >= 0);
    let error = null;

    if (id === 'sms_phone') {
      const parsedPhone = phone(value);
      error = parsedPhone.isValid ? null : 'Please input valid number';
    }
    return error;
  };

  const checkDetailValidate = () => {
    const keys = ['sms_phone'];
    const errors = {};
    keys.forEach(item => {
      const error = checkFieldValidate(item, notNull(values) ? values[item] : null);
      errors[item] = error;
    })
    setFieldErrors(errors);

    const stepValid = Object.keys(errors).filter(item => errors[item] !== null).length;
    return stepValid === 0;
  };

  const handleDetailChange = (id, newValue) => {
    setValues({
      ...values,
      [id]: newValue
    });
  }

  const handleSave = () => {
    if (!checkDetailValidate()) {
      return;
    }

    showCircularProgress('Saving...');
    passengersService.admin_edit({
      id: values.passenger_id,
      sms_phone: cleanPhone(values.sms_phone),
    }).then(({ data }) => {
      hideCircularProgress();
      if (data.status === 'SUCCESS') {
        updatePassengerDetail(values);
        handleEditClose();
      } else {
        showNotification('Sorry, Failed to save', 'error');
        if (data.data.code === 'NOT_LOGGED_IN') {
          logout();
          navigate('/login');
        }
      }
    });
  }

  return (
    <Dialog
      classes={{ paper: 'modal-content' }}
      fullWidth
      maxWidth="xs"
      open={editOpen}
      onClose={handleEditClose}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <DialogTitleContainer className="bg-secondary">
        <span>
          Edit Preferred SMS Phone
        </span>
      </DialogTitleContainer>
      <DialogContentContainer className="p-0" dividers>
        <div className="dialog-content--wrapper bg-secondary border-0">
          <div className="card-body px-lg-4 py-lg-3">
            <div className="card-body--column w-100">
              <MyCardRow>
                <PhoneInput
                  international
                  countryCallingCodeEditable={false}
                  initialValueFormat="national"
                  defaultCountry="US"
                  placeholder="Preferred SMS Phone"
                  value={values.sms_phone || values.phone}
                  onChange={val => handleDetailChange('sms_phone', val)}
                  numberInputProps={{
                    style: { ...(fieldErrors?.sms_phone && { border: '1px solid red' }) }
                  }}
                />
              </MyCardRow>
            </div>
          </div>
        </div>
      </DialogContentContainer>
      <DialogActionsContainer className="bg-secondary p-3">
        <Button
          size="small"
          className="btn-primary mxr-4 px-4 py-2 btn-transition-none"
          onClick={handleSave}
        >
          <span className="btn-wrapper--icon">
            <SaveTwoToneIcon fontSize="small" />
          </span>
          <span className="btn-wrapper--label">Save</span>
        </Button>
        <Button
          size="small"
          className="btn-warning px-4 py-2 btn-transition-none"
          onClick={handleEditClose}
        >
          <span className="btn-wrapper--icon">
            <ReplayTwoToneIcon fontSize="small" />
          </span>
          <span className="btn-wrapper--label">Cancel</span>
        </Button>
      </DialogActionsContainer>
    </Dialog>
  );
};

export default EditSmsPhoneModal;
